import React from 'react';
import './footer.css';

export default function Footer() {  
    return (
        <footer>
            <p className="footer-name">
                All rights reserved — Mohamed Bakoush
            </p>
            <section className="footer-credit"> 
                <p>
                    DESIGNED & DEV BY ME 
                </p>
            </section>
        </footer>
    );
} 